<template>
  <section class="aura-video">
    <!-- Decorative background circles -->
    <div class="bg-circle bg-circle-1"></div>
    <div class="bg-circle bg-circle-2"></div>

    <div class="video-inner">
      <p class="section-eyebrow">{{ $t('seeItInAction') }}</p>
      <h2 class="section-title">{{ $t('howitworks') }}</h2>
      <p class="section-sub">{{ $t('watchVideoPreview') }}</p>

      <!-- Big play button -->
      <button class="big-play-btn" @click="showYouTubeModal" :aria-label="$t('watchVideoPreview')">
        <span class="pulse-ring"></span>
        <span class="pulse-ring pulse-ring--delay"></span>
        <span class="play-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 5.14v14l11-7-11-7z"/>
          </svg>
        </span>
      </button>

      <p class="play-label">{{ $t('watchVideoPreview') }}</p>
    </div>

    <YTModal
      url="https://www.youtube.com/watch?v=p3ubzzbJVUQ"
      v-if="showModal"
      @close="showModal = false"
    />
  </section>
</template>

<script>
import YTModal from "../../components/YTModal";
export default {
  name: "VideoPromo",
  components: { YTModal },
  data() {
    return { showModal: false };
  },
  methods: {
    showYouTubeModal() {
      this.showModal = true;
    },
  },
};
</script>

<style scoped>
.aura-video {
  background: #0A7A76;
  padding: 96px 24px;
  overflow: hidden;
  position: relative;
  text-align: center;
}

/* ── Decorative circles ── */
.bg-circle {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.08);
  pointer-events: none;
}
.bg-circle-1 {
  width: 500px;
  height: 500px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bg-circle-2 {
  width: 750px;
  height: 750px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ── Content ── */
.video-inner {
  position: relative;
  z-index: 2;
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.section-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #F5A340;
  margin: 0;
}
.section-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(26px, 3vw, 42px);
  font-weight: 500;
  color: #fff;
  line-height: 1.2;
  margin: 0;
}
.section-sub {
  font-size: 16px;
  color: rgba(255,255,255,0.6);
  line-height: 1.75;
  font-weight: 300;
  margin: 0 0 16px;
}

/* ── Big play button ── */
.big-play-btn {
  position: relative;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0 0;
}
.play-icon {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: #F5A340;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  transition: transform 0.25s, background 0.25s;
  box-shadow: 0 8px 32px rgba(245, 163, 64, 0.45);
}
.big-play-btn:hover .play-icon {
  transform: scale(1.08);
  background: #f7b340;
}
.play-icon svg {
  width: 32px;
  height: 32px;
  color: #fff;
  margin-left: 4px;
}

/* ── Pulse rings ── */
.pulse-ring {
  position: absolute;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 2px solid rgba(245, 163, 64, 0.5);
  animation: pulse-out 2s ease-out infinite;
}
.pulse-ring--delay {
  animation-delay: 1s;
}
@keyframes pulse-out {
  0%   { transform: scale(1);   opacity: 0.6; }
  100% { transform: scale(2.2); opacity: 0; }
}

.play-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255,255,255,0.55);
  letter-spacing: 0.5px;
  margin: 4px 0 0;
}

@media (max-width: 480px) {
  .aura-video { padding: 64px 24px; }
}
</style>
